/*
 *   GTMEventTracker
 *   This script will make it possible to fire google analytics events via tagmanager by only using html data attributes.
 *   There are 3 kind of triggers
 *   ---------------
 *   - click:    This will trigger a google analytics event when clicked on the element the attribute was added to
 *   - load:     This will trigger a google analytics event on page load
 *   - submit:   This will trigger a google analytics event after submitting a form
 *   ---------------
 *
 *   The following data-attributes are available
 *   ---------------
 *   - data-gtm-event (required):        This can hold one of the options as stated above (click, load, submit)
 *   - data-gtm-category (required):     This holds the event category as passed on to google analytics
 *   - data-gtm-action (required):       This holds the event action as passed on to google analytics
 *   - data-gtm-label (optional):        This holds the event label as passed on to google analytics.
 *                                       If not set it will be passed on as an empty string
 */

export const init = function () {
  window.addEventListener("click", function (e) {
    handleClickListener(e);
  });
  window.addEventListener("load", function () {
    handleLoadListener();
  });
  window.addEventListener("submit", function (e) {
    handleSubmitListener(e);
  });
};

const handleClickListener = function (e) {
  const element = e.target.closest("[data-gtm-event=click]"); //Get click element
  if (element) {
    _extractEventData(element);
  }
};

const handleLoadListener = function () {
  const elements = document.querySelectorAll('[data-gtm-event="load"]');
  [].forEach.call(elements, function (element) {
    _extractEventData(element, 1);
  });
};

const handleSubmitListener = function (e) {
  // Handle everything for the submit handler
  const form = e.target;
  if (form.matches('[data-gtm-event="submit"]')) {
    _extractEventData(form);
  }
};

export const trackEvent = function (category, action, label, nonInteraction) {
  //Check if nonInteraction is defined, if not set a default value
  if (!nonInteraction) {
    nonInteraction = 0; // Default = 0 = false
  }
  // Make sure the global variable "dataLayer" is defined
  if (typeof dataLayer !== "undefined") {
    dataLayer.push({
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventNonInteraction: nonInteraction,
      event: "GAEvent",
    });
  }
};

const _extractEventData = function (element, nonInteraction) {
  let data = {};

  //Check if nonInteraction is defined, if not set a default value
  if (!nonInteraction) {
    nonInteraction = 0; // Default = 0 = false
  }

  if (element) {
    // Get all relevant data from data attributes
    data = {
      trigger: element.getAttribute("data-gtm-trigger"),
      category: element.getAttribute("data-gtm-category"),
      action: element.getAttribute("data-gtm-action"),
      label: element.getAttribute("data-gtm-label"),
    };
  }

  //Push event
  if (data.category || data.action) {
    trackEvent(data.category, data.action, data.label, nonInteraction); //Push data to datalayer
  }
};
